import React, { useEffect, useState } from "react";
import { Typography, Grid, IconButton, Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { MenuItem, FormControl, Select } from "@mui/material";
import _ from "lodash";
import { addDefaultOpt } from "../../../../../../utils/helpers";

const fontSx = {
  fontSize: ["1rem", "1rem", "1rem", "1rem", "1.5rem", "1.5rem"],
};

const RegionSelector = ({
  disabled,
  selectedRegion,
  initialRegion,
  regions,
  onRegionChange,
}) => {
  const [regionOptions, setRegionOptions] = useState([]);

  useEffect(() => {
    const allRegions =
      initialRegion in regions
        ? regions
        : {
          [initialRegion]: "all",
          ..._.omit(regions, ["mosquito", "tick"]),
        };
    setRegionOptions(
      addDefaultOpt(
        Object.entries(allRegions)?.map(([option, optionName]) => {
          return {
            value: option,
            label: option === initialRegion ? `${optionName} (*)` : optionName,
          };
        })
      )
    );
  }, [initialRegion, regions]);

  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  return (
    <>
      <Grid size={4}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography sx={fontSx} className={"text-gray-600"}>
            Select Region:
            <IconButton size="small" sx={{ p: 0, ml: 1 }} onClick={handleDialogOpen}>
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Typography>

          <Dialog open={open} onClose={handleDialogClose} maxWidth="sm" fullWidth>
            <DialogContent dividers>
              <Typography gutterBottom>
                For the best classification result, select the region where your mosquitoes were caught.
                Our methodology labels mosquitoes identified as species not found in the region where
                they were collected as 'unknown'.
              </Typography>
              <Typography gutterBottom>
                To view the countries and/or states and the list of species within each region,
                click <em>"Find My Region"</em> below.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogClose}>Close</Button>
            </DialogActions>
          </Dialog>

        </div>
      </Grid>
      <Grid size={8}>
        <FormControl fullWidth disabled={disabled}>
          <Select
            labelId="region-select-label"
            id="region-select"
            value={regionOptions.length === 1 ? '' : selectedRegion}
            onChange={(e) => onRegionChange(e.target.value)}
            style={{ height: 35 }}
          >
            {regionOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
};

export default RegionSelector;
